import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private $counterPeriod = 120000;
  private $authInfoKeyName = 'access_token';
  private $prefix = 98;
  private $buttonDebounceTime = 200;
  private $devicesWidth = {
    mobile: {min: '0', max: '767'},
    tablet: {min: '768', max: '1280'},
    desktop: {min: '1281'},
  };

  get buttonDebounceTime(): number {
    return this.$buttonDebounceTime;
  }

  get counterPeriod(): number {
    return this.$counterPeriod;
  }

  get authInfoKeyName(): string {
    return this.$authInfoKeyName;
  }

  get prefix(): number {
    return this.$prefix;
  }

  get deviceWidth() {
    return this.$devicesWidth;
  }
}
